import { ThemeOptions } from '@mui/material';

import { tokens } from '../../../theme/generated/tokens';
import { activeProps } from '../../../theme/utils';

export const dropdownsTheme: ThemeOptions['components'] = {
  DsDropdown: {
    styleOverrides: {
      root: ({ theme }) => ({
        '&& .DS-DropdownInput-popupOpen > .DS-DropdownInput-inputWrapper': {
          ...activeProps(theme),
        },
        '&.DS-Dropdown-withPrefix': {
          '&.DS-Dropdown-size': {
            '&Sm': {
              '& .DS-Dropdown-DropdownPrefix': {
                ...theme.typography.P12R,
                paddingLeft: '8px',
                paddingRight: '8px',
              },
            },
            '&Md': {
              '& .DS-Dropdown-DropdownPrefix': {
                ...theme.typography.P14R,
                paddingLeft: '10px',
                paddingRight: '10px',
              },
            },
            '&Lg': {
              '& .DS-Dropdown-DropdownPrefix': {
                ...theme.typography.P14R,
                paddingLeft: '12px',
                paddingRight: '12px',
              },
            },
          },
          '&.DS-Dropdown-root .MuiInputLabel-root, &.DS-Dropdown-root .MuiFormHelperText-root':
            {
              gridColumn: '1 / -1',
            },
          '& .DS-DropdownInput-inputWrapper.MuiInputBase-root': {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          },
          '& .DS-Input-startOutsideAdornment': {
            borderTopLeftRadius: '4px',
            borderBottomLeftRadius: '4px',
            border: '1px solid',
            borderColor: tokens.theme.border.structural.neutral,
            borderRight: 'none',
          },
          '& .DS-Dropdown-DropdownPrefix': {
            width: 'max-content',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            color: tokens.theme.fg.structural.primary,
            backgroundColor: tokens.theme.bg.structural.surfaceRaised,
            borderTopLeftRadius: 'inherit',
            borderBottomLeftRadius: 'inherit',
          },
        },
      }),
      popper: () => ({
        padding: '4px 0',
      }),
      list: () => ({
        '& .DS-DropdownList-groupHeader': {
          backgroundColor: tokens.theme.bg.structural.surface,
        },
        '& .DS-DropdownList-clearAllButton': {
          '& .MuiListItemText-root': {
            color: tokens.theme.fg.action.primary,
          },
        },
        '& .DS-Option-selected:not(.DS-Option-checkable)': {
          backgroundColor: tokens.theme.bg.selection.primarySubtle,
          color: tokens.theme.fg.selection.onPriamrySubtle,
          '&:hover': {
            backgroundColor: tokens.theme.bg.selection.primarySubtleHover,
            color: tokens.theme.fg.selection.onPriamrySubtleHover,
          },
          '& .MuiListItemText-root': {
            color: 'inherit',
          },
          '& .MuiListItemText-primary': {
            color: 'inherit',
          },
        },
        '& .DS-Option-selected.DS-Option-checkable': {
          backgroundColor: tokens.theme.bg.selection.primarySubtle,
          color: tokens.theme.fg.selection.onPriamrySubtle,
          '&:hover': {
            backgroundColor: tokens.theme.bg.selection.primarySubtleHover,
            color: tokens.theme.fg.selection.onPriamrySubtleHover,
          },
          '& .MuiListItemText-primary': {
            color: 'inherit',
          },
        },
        '& .DS-Option-subItem': {
          paddingLeft: '32px',
        },
        '& .DS-Option .DsListItem-content .DsListItem-root:first-of-type': {
          padding: 0,
        },
      }),
      input: () => ({
        cursor: 'pointer',

        '& .DS-DropdownInput-inputWrapper': {
          '&:not(.Mui-disabled)': {
            cursor: 'inherit',
          },
          '& input': {
            cursor: 'inherit',
            caretColor: 'transparent',
          },
        },
        '& .DS-Dropdown-endAdornmentWrapper': {
          height: '100%',
          alignItems: 'center',
          display: 'flex',
          gap: '10px',
          whiteSpace: 'nowrap',
        },
        '&& .DS-Dropdown-arrow': {
          '&:not(.Mui-disabled)': {
            color: tokens.theme.fg.structural.secondary,
          },
          fontSize: '16px',
        },

        '& .DS-Input-startAdornment-root:empty': {
          display: 'none',
        },
        '&.DS-DropdownInput-multipleValueSelected.DS-DropdownInput-popupClosed':
          {
            '& input': {
              opacity: 0,
              display: 'none',
            },
            '& .DS-Input-startAdornment-root': {
              flexGrow: 1,
              paddingRight: 0,
            },
          },
        '& .DS-Dropdown-startAdornmentWrapper': {
          display: 'flex',
          gap: '10px',
          alignItems: 'center',
          width: 'max-content',
          '& .DS-Dropdown-multiValueTextWrapper': {
            display: 'flex',
            gap: '8px',
            alignItems: 'center',
            color: tokens.theme.fg.structural.primary,
            '& .DS-Dropdown-multiValueText:not(.disabled):not(.selected)': {
              color: tokens.theme.fg.structural.secondary,
            },
            '& .DS-Dropdown-multiValueText.DS-Dropdown-emptyDropdown:not(.disabled)':
              {
                color: tokens.theme.fg.structural.secondary,
              },
            '& .DS-Dropdown-multiValueText.disabled': {
              color: tokens.theme.disabled.fg,
            },
            '& .DS-Dropdown-multiValueCount': {
              lineHeight: 'calc(var(--ds-input-lineHeight) - 2px)',
              display: 'inline-flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '0px 8px',
              minWidth: '25px',
              borderRadius: '40px',
              boxSizing: 'border-box',
              backgroundColor: tokens.theme.bg.selection.primaryHover,
              color: tokens.theme.fg.selection.onPrimary,
              '&.disabled': {
                backgroundColor: tokens.theme.disabled.bg,
              },
            },
          },
        },
      }),
    },
  },
};
